<template>
  <form v-if="value">
    <analysis-form-field
      v-if="!$route.params.analysisId || $route.params.analysisId === 'all'"
      label="Analisi"
      :value="value.analysisIds"
      multiple
      input-id
      output-id
      :disabled="disabled"
      :error="findError('analysisIds')"
      @input="propertyChanged('analysisIds', $event)"
    />
    
    <string-form-field
      label="Titolo"
      :value="value.title"
      :disabled="disabled"
      :error="findError('title')"
      @input="propertyChanged('title', $event)"
    />

    <string-form-field
      label="Descrizione"
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      @input="propertyChanged('description', $event)"
    />
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
